export default __webpack_public_path__ + "static/media/50_desktop.228c8ac2.jpg";